import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import SenseView from "../views/SenseView.vue";
import ModernView from "../views/ModernView.vue";
import WildtechView from "../views/WildtechView.vue";
import AnomalaView from "../views/AnomalaView.vue";
import BroomxView from "../views/BroomxView.vue";
import UnitsView from "../views/UnitsView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    props: true,
  },
  {
    path: "/sense",
    name: "sense",
    component: SenseView,
    props: true,
  },
  {
    path: "/modern",
    name: "modern",
    component: ModernView,
    props: true,
  },
  {
    path: "/wildtech",
    name: "wildtech",
    component: WildtechView,
    props: true,
  },
  {
    path: "/anomala",
    name: "anomala",
    component: AnomalaView,
    props: true,
  },
  {
    path: "/broomx",
    name: "broomx",
    component: BroomxView,
    props: true,
  },
  {
    path: "/units",
    name: "units",
    component: UnitsView,
    props: true,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
